import { t } from "@/i18n-js/instance";
import { EmptyState } from "@circle-react-uikit/EmptyState";

export const SuggestedSpacesEmptyState = () => (
  <div data-testid="suggested-spaces-empty-state">
    <EmptyState
      header={t("feed")}
      description={t("landing_page.settings.empty_suggested_spaces_text")}
    />
  </div>
);
